import { Row, Button, Col } from 'antd';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { UserStore } from '../../stores';
import { ConsultaStore } from '../../stores/consultaStore';
import FiltrosUsuarios from './filtrosUsuarios';
import TablaUsuarios from './tablaUsuarios';
import { ModalUsuario } from './ModalUsuarios';

const ConsultasWrapper = styled.div`
    margin: 0 auto;
    padding: 0 150px;
    max-width: 1600px;
`;

const PageHeader = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;

interface UsuariosInnerProps extends RouteComponentProps {
    userStore?: UserStore;
    consultaStore?: ConsultaStore;
}


@inject('consultaStore')
@inject('userStore')
@observer
class UsuariosInner extends React.Component<UsuariosInnerProps, {}> {
    async componentDidMount() {
        const { userStore, consultaStore } = this.props;
        await consultaStore!.getRoles();
        await consultaStore!.getMunicipios();
        await consultaStore!.getOrganismosOperadores();
        await consultaStore!.getCargos();
        await userStore!.getUsuarios();
    }

    renderAddUsuarioButton = () => {
        return (
            <>
                <Button
                    type='dashed'
                    icon='plus'
                    style={{ height: '100px', whiteSpace: 'normal' }}
                    block={true}
                    onClick={this.clickAddUsuario}
                >
                    Añadir un nuevo usuario
                </Button>
            </>
        )
    }

    clickAddUsuario=()=>{
        const {userStore}=this.props;
        userStore!.openModal=true;
        userStore!.tipoModal='Alta';
    }

    render() {
        return (
            <ConsultasWrapper>
                <Row style={{textAlign:'center'}}>
                        <PageHeader>Administración de usuarios</PageHeader>
                    </Row>
                <Row >
                    <Col span={8}>
                        {this.renderAddUsuarioButton()}
                    </Col>
                </Row>
                <Row style={{paddingTop:'20px'}} className="justify-content-md-center" >
                    <FiltrosUsuarios />
                </Row>
                <Row>
                    <TablaUsuarios />
                </Row>
                <ModalUsuario />
            </ConsultasWrapper>
        );
    }
}
export const Usuarios = withRouter(UsuariosInner);
